import React, {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const ReferralRedirect = () => {
  const [searchParams, _] = useSearchParams();
  const {user} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!searchParams.has('invite-code') || user) {
      navigate('/soft-check');
    } else {
      const rawInviteCode = searchParams.get('invite-code')?.toString();
      // Temporary fix for malformed URLs from deep link handler
      // Remove any trailing "/?time=..." that may have been incorrectly appended
      const inviteCode = rawInviteCode?.split('/?')[0];
      navigate('/register', {state: {code: inviteCode}});
    }
  }, [searchParams]);

  return <></>;
};

export default ReferralRedirect;
